import styled from 'styled-components';
import { th } from 'style/theme';

const Title = styled.h6`
  color: ${th('colors.silverGray')};
  font-weight: 400;
  font-size: 16px;
  margin: 0;
`;

export default Title;
